import * as React from 'react';
import { SVGProps } from 'react';

const SvgReferral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M36.125 30.6016H7.9635V11.5547H36.125V30.6016Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M7.87499 30.55H5.89642L3 13.55H8"
    />
    <path
      fill="currentColor"
      d="M28.4056 20.8727L23.1373 17.0016V25.2204L28.4138 20.8727H28.4056Z"
    />
    <path
      fill="currentColor"
      d="M24.6701 19.5906H16.4513V22.6726H24.6701V19.5906Z"
    />
    <path
      fill={props.fill}
      d="M7.2135 12.8594V8.77055L15.4323 8.75L19.5417 12.8594H7.2135Z"
    />
  </svg>
);

export default SvgReferral;
